import { motion } from "framer-motion";
import { Instagram, Mail } from "lucide-react";
import { EMAIL, IG_URL, M, EASE, scrollToId } from "../lib/site";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-[var(--line)]" data-testid="site-footer">
    <div className="absolute inset-0">
      <img src={M.ceiling} alt="" className="h-full w-full object-cover opacity-25" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#09080B] via-[#09080B]/80 to-[#09080B]" />
    </div>
    <div className="relative mx-auto max-w-[1400px] px-5 pb-10 pt-24 sm:px-10">
      <motion.img src={M.logo} alt="Eleganté" data-testid="footer-logo"
        initial={{ clipPath: "inset(0 100% 0 0)" }} whileInView={{ clipPath: "inset(0 0% 0 0)" }}
        viewport={{ once: true, amount: 0.1 }} transition={{ duration: 2, ease: EASE }}
        className="mx-auto w-full max-w-[900px] opacity-90" />
      <p className="mt-6 text-center font-mono-x text-xs uppercase tracking-[0.3em] text-[var(--glow)]">Every Friday · 9PM til late</p>
      <div className="mt-16 flex flex-col items-center justify-between gap-6 border-t border-[var(--line)] pt-8 text-sm text-[var(--stone)] sm:flex-row">
        <p>© {new Date().getFullYear()} Eleganté Melbourne · Level 1/412 Little Collins St</p>
        <div className="flex items-center gap-6">
          <a href={IG_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-ig-link" className="transition-colors hover:text-[var(--glow)]"><Instagram size={18} /></a>
          <a href={`mailto:${EMAIL}`} aria-label="Email" data-testid="footer-email-link" className="transition-colors hover:text-[var(--glow)]"><Mail size={18} /></a>
          <button onClick={() => scrollToId("top")} data-testid="footer-top-btn" className="uppercase tracking-[0.2em] transition-colors hover:text-[var(--glow)]">Back to top ↑</button>
        </div>
      </div>
    </div>
  </footer>
);
